import styled, {css} from "styled-components"

import {onePxThick} from "@irati/ui/src/global/elevation"
import {WorkSansMedium, WorkSansBold} from "@irati/ui/src/global/fonts"

export interface TagCssProps {
  tag?: boolean
  selected?: boolean
  light?: boolean
  isWellness?: boolean
}
export const TagCss = css<TagCssProps>`
  display: inline-block;
  border-radius: 81px;
  padding: 10px 30px;
  margin: 5px 10px 10px 1px;
  text-align: center;
  text-transform: uppercase;
  font-size: ${({tag}) => (tag ? "10px" : "12px")};
  line-height: ${({tag}) => (tag ? "12px" : "16px")};
  color: ${({theme, selected}) => (selected ? theme.colors.greys.white : theme.colors.greys.black)};
  background-color: ${({theme, selected, isWellness}) =>
    selected ? (isWellness ? theme.colors.perkbox.blue : theme.colors.greys.mediumDark) : theme.colors.greys.white};
  letter-spacing: 0.2px;

  ${({light}) => (light ? WorkSansMedium : WorkSansBold)}
  ${onePxThick}

  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
`

export const TagElement = styled.span<TagCssProps>`
  ${TagCss}
`
